var base62, crypto;

crypto = require("crypto");

base62 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

module.exports = function(size) {
  var bytes, j, key;
  if (size == null) {
    size = 40;
  }
  if (size < 1) {
    throw new Error("bad size");
  }
  key = "";
  bytes = crypto.randomBytes(size * 3);
  j = 0;
  while (key.length < size) {
    if (j >= bytes.length) {
      bytes = crypto.randomBytes(size);
      j = 0;
    }
    while (bytes[j] >= 62) {
      j++;
      if (j >= bytes.length) {
        bytes = crypto.randomBytes(size);
        j = 0;
      }
    }
    if (j >= bytes.size) {
      throw new Error("internal error");
    }
    key += base62[bytes[j++]];
  }
  return key;
};



//////////////////
// WEBPACK FOOTER
// ./~/apikeygen/dist/lib/apikey.js
// module id = 501
// module chunks = 0